import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import { TextInput, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import addIcon from "@icons/ic-add-green.svg";
import plateEnableIcon from "@icons/plate-enable.svg";
import plateDisableIcon from "@icons/plate-disable.svg";
import saveIcon from "@icons/ic-yes-green.svg";
import cancelIcon from "@icons/ic-edit-cancel.svg";
import {
  PlateListContainer,
  GridRow,
  ContactButton,
  PlateText,
  Title,
  GridRowTitle,
} from "./TruckPlateList.styled";
import "../../WarehouseView.scss";
import { handleApiError } from "@utils/errorHandler";

/**
 * Warehouse truck plate List,
 * Path - /companies/{companyId}/hauliers/{haulierId}/warehouses
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2951905281/Company+view+page+-+Warehouse+view+page)
 * @component
 */
const TruckPlateList = (props) => {
  const { t, plateData, truckId, updateWarehouseRefeshStatus } = props;

  const [plateValue, setPlateValue] = useState("");
  const [updateTruckId, setUpdateTruckId] = useState("");
  const [isTruckPlateCreating, setTruckPlateCreating] = useState(false);

  const plateEnableDisable = (plateId, status) => {
    axios
      .post(
        `/trucks/${truckId}/plates/${plateId}/updateStatus`,
        status ? `0` : 1
      )
      .then(() => {
        updateWarehouseRefeshStatus(true);
      })
      .catch((error) => {
        updateWarehouseRefeshStatus(false);
        handleApiError(error);
      });
  };
  const onChangePlate = (e, plateId) => {
    setUpdateTruckId(plateId);
    setPlateValue(e.target.value);
  };
  const toggleSaveBtn = (id) => {
    setUpdateTruckId(id);
  };
  const cancelToggleSaveBtn = () => {
    setUpdateTruckId("");
    setPlateValue("");
  };

  const onSave = () => {
    if (plateValue && plateValue !== "") {
      setTruckPlateCreating(true);
      const data = {
        id: "",
        plate: plateValue,
        isActive: true,
      };
      axios
        .post(`/trucks/${updateTruckId}/plates`, data)
        .then(() => {
          setTruckPlateCreating(false);
          updateWarehouseRefeshStatus();
          setUpdateTruckId("");
          setPlateValue("");
        })
        .catch((error) => {
          setTruckPlateCreating(false);
          setUpdateTruckId("");
          setPlateValue("");
        });
    }
  };

  return (
    <>
      <GridRowTitle column="1fr">
        <Title>
          <PlateListContainer content="flex-start">
            {t("WAREHOUSE_TRUCK_PLATES_TITLE")}
            {updateTruckId !== truckId && (
              <Image
                src={addIcon}
                onClick={() => toggleSaveBtn(truckId)}
                alt={t("WAREHOUSE_TRUCK_PLATES_ADD_TOOLTIP")}
                title={t("WAREHOUSE_TRUCK_PLATES_ADD_TOOLTIP")}
                className="warehouse-view__add-icon"
              />
            )}

            {updateTruckId === truckId && (
              <>
                <TextInput
                  type="text"
                  label=""
                  name="truck-plate"
                  id="truck-plate"
                  value={String(plateValue) || ""}
                  onChange={(e) => onChangePlate(e, truckId)}
                  inputStyles={{
                    padding: "3px 5px 3px 4px",
                    marginLeft: "10px",
                    marginRight: "10px",
                    maxWidth: "6rem",
                  }}
                  error=""
                  placeholder=""
                />
                {!isTruckPlateCreating && (
                  <>
                    <Image
                      src={saveIcon}
                      className="warehouse-__action-icon"
                      onClick={onSave}
                      alt={t("WAREHOUSE_TRUCK_PLATE_VALIDATE_TOOLTIP")}
                      title={t("WAREHOUSE_TRUCK_PLATE_VALIDATE_TOOLTIP")}
                    />
                    <Image
                      src={cancelIcon}
                      className="warehouse-__action-icon"
                      onClick={cancelToggleSaveBtn}
                      alt={t("WAREHOUSE_TRUCK_PLATE_CANCEL_TOOLTIP")}
                      title={t("WAREHOUSE_TRUCK_PLATE_CANCEL_TOOLTIP")}
                    />
                  </>
                )}
                {isTruckPlateCreating && <ClipLoader size={15} color="#fff" />}
              </>
            )}
          </PlateListContainer>
        </Title>
      </GridRowTitle>
      {plateData?.length > 0 && (
        <GridRow>
          {plateData?.map((plateInfo, plateIndex) => {
            return (
              <ContactButton
                border={plateInfo.isActive ? "#008395" : "#cccccc"}
                background={plateInfo.isActive ? "#008395" : "#cccccc"}
                key={"warehouse-plate-" + plateIndex + "-" + plateInfo?.id}
              >
                <PlateListContainer>
                  <PlateText color="#fff">{plateInfo?.plate}</PlateText>

                  <Image
                    src={
                      plateInfo.isActive ? plateDisableIcon : plateEnableIcon
                    }
                    onClick={() =>
                      plateEnableDisable(plateInfo.id, plateInfo.isActive)
                    }
                    alt={
                      plateInfo.isActive
                        ? t("WAREHOUSE_TRUCK_PLATE_DISABLE_TOOLTIP")
                        : t("WAREHOUSE_TRUCK_PLATE_ENABLE_TOOLTIP")
                    }
                    title={
                      plateInfo.isActive
                        ? t("WAREHOUSE_TRUCK_PLATE_DISABLE_TOOLTIP")
                        : t("WAREHOUSE_TRUCK_PLATE_ENABLE_TOOLTIP")
                    }
                    className="warehouse-view__truck-icon"
                  />
                </PlateListContainer>
              </ContactButton>
            );
          })}
        </GridRow>
      )}
      {plateData?.length === 0 && (
        <GridRowTitle column="1fr">
          {t("WAREHOUSE_TRUCKS_NO_PLATES")}
        </GridRowTitle>
      )}
    </>
  );
};

TruckPlateList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TruckPlateList);
